module.exports = __webpack_public_path__ + "img/privacy_bg.a199bbe9.jpg";